import { makeStyles, Text, useTheme } from '@rneui/themed'
import { t } from 'app/i18l'
import React from 'react'
import { ActivityIndicator, View } from 'react-native'

interface Props {
  text?: string
}

export default function Loading(props: Props) {
  const { theme } = useTheme()
  const styles = useStyles()
  return (
    <View style={styles.container}>
      <Text style={styles.text}>{props.text ?? t('loading')}</Text>
      <ActivityIndicator color={theme.colors.primary} />
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  container: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors?.white,
    paddingHorizontal: 40,
  },
  text: {
    paddingBottom: 20,
  },
}))
